import CroustilleElement from "../lib/CroustilleElement";

class Splash extends CroustilleElement {
  constructor() {
    super("splash");
  }

  hide() {
    this.dataset.hidden = true;
    document.documentElement.dataset.splash = "hidden";
  }

  show() {
    this.dataset.hidden = false;
    document.documentElement.dataset.splash = "visible";
  }

  handleClick() {
    this.hide();
  }

  handleKeyDown(e) {
    const evt = e || window.event;
    if (evt.keyCode === 27) {
      this.hide();
    }
  }

  handleScroll() {
    this.hide();

    document.removeEventListener("DOMMouseScroll", this._handleScroll);
  }

  init() {
    this.show();
    this._handleClick = this.handleClick.bind(this);
    this._handleScroll = this.handleScroll.bind(this);
    this._handleKeyDown = this.handleKeyDown.bind(this);

    this.addEventListener("click", this._handleClick);
    document.addEventListener("barba", this._handleClick);
    document.addEventListener("DOMMouseScroll", this._handleScroll);
    document.addEventListener("touchstart", this._handleClick);
    document.addEventListener("keydown", this._handleKeyDown);
  }

  destroy() {
    this.removeEventListener("click", this._handleClick);
    document.removeEventListener("touchstart", this._handleClick);
    document.removeEventListener("keydown", this._handleKeyDown);
    document.removeEventListener("barba", this._handleClick);
  }
}

export default Splash;
